import { SxProps, Theme } from '@mui/material';

const pageTitle: SxProps<Theme> = () => ({
  marginBottom: 4,
});

export default {
  pageTitle,
};
